module.exports = __webpack_public_path__ + "static/media/logo beetPOS new.412bed81.png";